"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop2 = _interopRequireDefault(require("lodash/noop"));

var _BodyRow = _interopRequireDefault(require("./BodyRow"));

var _excluded = ["dataList", "columns", "emptyMessage", "rowClick", "rowClassName", "onRemoveItem", "onDropdownSelect"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TableBody(_ref) {
  var dataList = _ref.dataList,
      columns = _ref.columns,
      emptyMessage = _ref.emptyMessage,
      rowClick = _ref.rowClick,
      rowClassName = _ref.rowClassName,
      _ref$onRemoveItem = _ref.onRemoveItem,
      onRemoveItem = _ref$onRemoveItem === void 0 ? _noop2.default : _ref$onRemoveItem,
      _ref$onDropdownSelect = _ref.onDropdownSelect,
      onDropdownSelect = _ref$onDropdownSelect === void 0 ? _noop2.default : _ref$onDropdownSelect,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      cellToShowDropdown = _useState2[0],
      setCellToShowDropdown = _useState2[1];

  var handleAddElementToDropdown = (0, _react.useCallback)(setCellToShowDropdown, []);
  var handleDimmerClick = (0, _react.useCallback)(function () {
    setCellToShowDropdown(null);
  }, []);
  var handleSelect = (0, _react.useCallback)(function (values, fieldData) {
    onDropdownSelect(values, fieldData);
    setCellToShowDropdown(null);
  }, [onDropdownSelect, setCellToShowDropdown]);
  var handleRowClick = (0, _react.useCallback)(function (data) {
    if (rowClick) rowClick(data);
  }, [rowClick]);
  var handleRemoveItem = (0, _react.useCallback)(function (data) {
    if (onRemoveItem) onRemoveItem(data);
  }, [onRemoveItem]);
  var bodyRowProps = {
    columns: columns,
    dataList: dataList,
    onDimmerClick: handleDimmerClick,
    onSelectDropdownOption: handleSelect,
    onRowClick: handleRowClick,
    onRemoveItem: handleRemoveItem,
    onAddElementToDropdown: handleAddElementToDropdown,
    cellToShowDropdown: cellToShowDropdown
  };
  return dataList.length > 0 ? dataList.map(function (data) {
    return /*#__PURE__*/_react.default.createElement(_BodyRow.default, _extends({
      key: data.id,
      id: data.id,
      data: data
    }, bodyRowProps, props));
  }) : /*#__PURE__*/_react.default.createElement("tr", {
    tabIndex: "0",
    className: rowClassName
  }, /*#__PURE__*/_react.default.createElement("td", {
    className: "text-center p-16 text-3xl",
    colSpan: columns.length
  }, emptyMessage));
}

TableBody.propTypes = {
  columns: _propTypes.default.array,
  dataList: _propTypes.default.array,
  emptyMessage: _propTypes.default.string,
  rowClick: _propTypes.default.func,
  rowClassName: _propTypes.default.string,
  onDropdownSelect: _propTypes.default.func,
  onRemoveItem: _propTypes.default.func
};
TableBody.defaultProps = {
  dataList: [],
  columns: [],
  emptyMessage: 'No se encontró ningún elemento'
};
var _default = TableBody;
exports.default = _default;